import { RootState } from 'data/root.reducers';
import { Filters } from './filters.types';

export const getFiltersList = (state: RootState): Filters[] =>
  state.filters.entities;
export const getFilters = (state: RootState): Filters | null =>
  state.filters.single;
export const getSelectedFilters = (state: RootState): Filters[] =>
  state.filters.selected;
export const getFiltersCreatedId = (state: RootState): string | null =>
  state.filters.createdId;

export const isFiltersCreatePopupOpen = (state: RootState): boolean =>
  state.filters.ui.isCreatePopupOpen;
export const isFiltersEditPopupOpen = (state: RootState): boolean =>
  state.filters.ui.isEditPopupOpen;
export const isFiltersLoading = (state: RootState): boolean =>
  state.filters.ui.isLoading;
